import React from "react";

import MainContainer from "../components/MainContainer";
import Login from "../components/Login/Login";
import UserHeader from "../components/User/UserHeader";
import { useTranslation } from "react-i18next";

const LoginPage = () => {
  const { t } = useTranslation();
  return (
    <div className="App page-user">
      <MainContainer>
        <div className="finbb-container">
          <UserHeader title={t("login_form_title")} />
          <Login />
        </div>
      </MainContainer>
    </div>
  );
};

export default LoginPage;
